import { ReactNode, CSSProperties } from "react";
import { cn } from "~/lib/utils";

type ElementorContainerProps = {
    children: ReactNode;
    className?: string;
    innerClassName?: string;
    contentWidth?: string;
    rowGap?: string;
    columnGap?: string;
};

const ElementorContainer = ({
    children,
    className,
    innerClassName,
    contentWidth = "1920px",
    rowGap = "20px",
    columnGap = "20px",
}: ElementorContainerProps) => {
    const styles = {
        "--content-width": contentWidth,
        "--row-gap": rowGap,
        "--column-gap": columnGap,
    } as CSSProperties;

    return (
        <section className={cn("w-full", className)} style={styles}>
            <div
                className={cn(
                    "mx-auto flex h-full w-full max-w-[var(--content-width)] px-6",
                    "gap-0 min-[380px]:gap-[var(--row-gap)_var(--column-gap)]",
                    "min-[1025px]:px-12",
                    "min-[1280px]:px-16",
                    "min-[1440px]:px-20",
                    "min-[1728px]:px-[144px]",
                    innerClassName,
                )}
            >
                {children}
            </div>
        </section>
    );
};

export default ElementorContainer;